import { Button } from '@altibox/design-system-component-lib';
// eslint-disable-next-line import/no-unresolved
import { ButtonProps } from '@altibox/design-system-component-lib/dist/components/button/button';
import React, { FunctionComponent } from 'react';

import { arrowDisabledImageProps, arrowWhiteImageProps } from 'app/resources/images';

import { StyledArrowRight } from './navigation-button.styled';

type Props = Omit<ButtonProps, 'iconWrapper'>;

export const NavigationButton: FunctionComponent<Props> = (props) => {
    const { disabled, ...rest } = props;

    return (
        <Button
            iconWrapper={{
                icon: <StyledArrowRight {...(disabled ? arrowDisabledImageProps : arrowWhiteImageProps)} />,
            }}
            disabled={disabled}
            {...rest}
        />
    );
};
